import { Immutable } from "immer";
import React from "react";

import type { MoreInfoBlock as Value } from "@reactivated";

import { RichTextBlock } from "@thelabnyc/thelabui/src/components/RichText";

type Props = Immutable<{
    value: Value;
}>;

/**
 * React port of the pillows-specific ``MoreInfoBlock`` (defined in
 * ``server/cms/components/more_info.py``). DOM mirrors the legacy Django
 * template ``cms/components/more_info.html`` exactly — a full-width band
 * with the chosen image applied as an inline ``background-image``, a plain
 * text title (CharBlock) and a RichText description.
 */
export const MoreInfoBlock = (props: Props): React.JSX.Element => {
    const v = props.value;
    const imageUrl = v.image?.url ?? "";
    return (
        <div
            className="more-info l-full-width"
            style={
                imageUrl ? { backgroundImage: `url(${imageUrl})` } : undefined
            }
        >
            <div className="l-capped-width">
                <div className="more-info__copy">
                    <div className="more-info__title">{v.title ?? ""}</div>
                    <div className="more-info__desc">
                        <RichTextBlock value={v.description ?? ""} />
                    </div>
                </div>
            </div>
        </div>
    );
};
